<template>
  <div class="flex flex-wrap items-center justify-between pr-2 pl-6 mt-4">
    <div 
    >
      <div class="flex items-center" v-if="getResults.length && hasRowChangeListener">
        <label for="perPage" class="mr-1">
          {{ $t('components.tools.lexis_bridger.rows') }}
        </label>
        <select 
          name="perPage" 
          v-model="itemsCount" 
          :disabled="!getResults.length"
          @change="onPerPageChange" 
          class="w-20 h-full outline-none font-bold bg-white border border-solid border-gray-200 pl-2 pr-4 py-1 rounded"
        >
          <option v-for="row in perPageOptions" :key="row" :value="row">
            {{ row }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <neo-pagination 
        v-if="getResults.length"
        :currentPage="pageNumber" 
        v-model="pageNumber" 
        @change="handlePageChange" 
        :totalPageCount="totalPages" 
        class="" 
        :pageLimit="5" 
        :showFirstAndLast="!isAllRunQueries" 
      />
    </div>
    <div>
      <label class="flex gap-3 h-full items-center cursor-pointer" v-if="getIsRedirectionScreen">
          <input
            type="checkbox"
            class="ml-auto h-5 w-5 text-blue-600 pl-2 rounded"
            :disabled="getHasMatches"
            v-model="noMatch"
            @change="handleNoMatch($event.target.checked)"
          />
          <span class="text-base-content-200">
            {{ $t('components.redirection_screen.no_match_found') }}
          </span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NeoPagination from "@shared/saas-components/pagination/index";
export default {
  name: 'CheckToolPagination',
  components: {
    NeoPagination
  },
  props: {
    perPageOptions: {
      type: Array,
      default: () => []
    },
    itemsCountProp: {
      type: Number,
      required: true
    },
    pageNumberProp: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    isAllRunQueries: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemsCount: this.itemsCountProp,
      pageNumber: this.pageNumberProp
    }
  },
  watch: {
    itemsCountProp(newVal) {
      this.itemsCount = newVal;
    },
    pageNumberProp(newVal) {
      this.pageNumber = newVal;
    }
  },
  beforeDestroy() {
    // reset the no match state when the component is destroyed
    this.handleNoMatch(false);
  },
  computed: {
    ...mapGetters([
      "getIsRedirectionScreen",
      "getResults",
      "getNoMatchesFlag",
      "getHasMatches"
    ]),
    noMatch: {
      get() {
        return this.getNoMatchesFlag
      },
      set() {
        this.handleNoMatch(!this.getNoMatchesFlag)
      }
    },
    hasRowChangeListener() {
      return !!this.$listeners['per-page-change'];
    }
  },
  methods: {
    ...mapActions([
      "handleNoMatch"
    ]),
    onPerPageChange() {
      this.$emit('per-page-change', this.itemsCount);
    },
    handlePageChange(page) {
      this.pageNumber = page;
      this.$emit('page-change', page);
    }
  }
}
</script>